<template>
  <v-card rounded="xl" elevation="3">
    <v-card-title class="font-weight-bold">Department Distribution</v-card-title>
    <v-divider />
    <v-card-text>
      <apexchart
          type="donut"
          height="360"
          :options="chartOptions"
          :series="series"
      />
    </v-card-text>
  </v-card>
</template>
<script setup>
const series = [44, 55, 13, 33]
const chartOptions = {
  labels: [
    'HR',
    'IT',
    'Accounts',
    'Marketing'
  ],
  colors: [
    '#2563EB',
    '#06B6D4',
    '#22C55E',
    '#F59E0B'
  ],
  chart: {
    animations: {
      enabled: true,
      easing: 'easeinout',
      speed: 1400
    }
  },
  legend: {
    position: 'bottom'
  },
  dataLabels: {
    enabled: false
  },
  stroke: {
    width: 0
  }
}

</script>